import { render, staticRenderFns } from "./EditShop.vue?vue&type=template&id=1c5e7fb0"
import script from "./EditShop.vue?vue&type=script&lang=js"
export * from "./EditShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports